import { createI18n } from 'vue-i18n'
import en from '../assets/translations/en'
import es from '../assets/translations/es'

export default defineNuxtPlugin(({ vueApp }) => {
  const i18n = createI18n({
    legacy: false,
    fallbackLocale: ['en'],
    globalInjection: true,
    locale: 'en',
    messages: {
      en,
      es,
    },
    preserveDirectiveContent: true,
  })

  vueApp.use(i18n)
})
